export var ApplePayButtonTypeEnumsObj = {
    PLAIN: "plain",
    ADD_MONEY: "add-money",
    BOOK: "book",
    BUY: "buy",
    CHECK_OUT: "check-out",
    CONTINUE: "continue",
    CONTRIBUTE: "contribute",
    DONATE: "donate",
    ORDER: "order",
    PAY: "pay",
    RELOAD: "reload",
    RENT: "rent",
    SET_UP: "set-up",
    SUBSCRIBE: "subscribe",
    SUPPORT: "support",
    TIP: "tip",
    TOP_UP: "top-up",
};
